<template>
	<div ref="box" v-if="selectdItem.preStyle.selfStyle" style="width: 100%;height: 100%;">
		<div @mouseleave.stop.prevent="iptEnter = false" @mouseenter.stop.prevent="iptEnter = true" :style="{
				...getBorder(),
				...getBorderRadius(),
				...getBg(selectdItem),
				...getPadding(selectdItem),
			}" v-if="!selectdItem.preStyle.selfStyle.showInput" @click="type == 'design'?'': search()"
			style="cursor: pointer;display: flex;align-items: center;">
			<i v-if="selectdItem.preStyle.selfStyle.showBtnIcon" class="el-icon-search"></i>
			<div style="margin-left: 4px;">
				{{selectdItem.preStyle.selfStyle.btnText}}
			</div>
		</div>

		<div v-if="selectdItem.preStyle.selfStyle.showInput" @mouseleave.stop.prevent="iptEnter = false"
			@mouseenter.stop.prevent="iptEnter = true">
			<div :style="{
				...getBorderRadius(),
			 	 ...getBorder(),
				width:getSearchWidth(selectdItem),
				maxWidth:type == 'design'?selectdItem.preStyle.selfStyle.iptWidth + 'px':innerWidth + 'px'
			 }" style="display: flex;align-items: center;width: 280px;">
				<el-input v-model="value" :style="{
					
					'--borderRadius':getIptPad(selectdItem),
					
					  '--placeholderSize':this.selectdItem.preStyle.selfStyle.plaSize + 'px'
				 }" :icon="selectdItem.preStyle.selfStyle.showBtnIcon?'el-icon-search':''" style="width: 100%;"
					:size="selectdItem.preStyle.selfStyle.iptType"
					:prefix-icon="selectdItem.preStyle.selfStyle.showPreIcon?'el-icon-search':''"
					:placeholder="$t('h.email')" class="input-with-select large-placeholder">
				</el-input>

				<button
				  @mouseleave.stop.prevent="enterBtn = false" @mouseenter.stop.prevent="enterBtn = true"
				  @click="sendEmail" :style="{
					  borderRadius:getIptBtnBr(),
				     	height:selectdItem.preStyle.selfStyle.iptType == ''?'40px':selectdItem.preStyle.selfStyle.iptType == 'medium'?'36px':'28px',
				     	width:selectdItem.preStyle.selfStyle.iptType == ''?'80px':selectdItem.preStyle.selfStyle.iptType == 'medium'?'66px':'56px',				  
				      ...getBtnBg(selectdItem),color:getBtnColor(selectdItem)}"
					style="border: solid 0px #fff;background-color: rgb(0 0 0 / 0%);cursor: pointer;">
					<i v-if="loading" class="el-icon-loading"></i>
					{{$t('h.send')}}
					{{selectdItem.preStyle.selfStyle.btnText}}</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		sendSubscribe
	} from '../../api/all.js'
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		watch: {
			drawer: function(val) {
				if (val == false) {
					this.value = ""
				}
			},
		},
		data() {
			return {
				innerWidth: 0,
					enterBtn: false,
				loading: false,
				iptEnter: false,
				showIpt: false,
				value: "",
				drawer: false
			}

		},
		mounted() {
			
			if (!this.selectdItem.preStyle.selfStyle.iptPad) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'iptPad', {
					borderRadius:[0,0,0,0]
				})
			}
			
			if(!this.selectdItem.preStyle.selfStyle.plaSize){
				this.$set(this.selectdItem.preStyle.selfStyle,'plaSize',20)
			}
			if (!this.selectdItem.preStyle.selfStyle.btnHover) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'btnHover', {
					color: "",
					bg: {
						bgtype: "color", // color gradient
						bgGradient: "",
						color: "",
					},
				})
			}
			
			this.innerWidth = this.$refs.box.offsetWidth;
		},
		methods: {
			getIptBtnBr(){
				if(this.selectdItem.preStyle.selfStyle.iptPad){
					return ` 0px ${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[2]}px  0px`
				}
			},
			getIptPad(){
				if(this.selectdItem.preStyle.selfStyle.iptPad){
					console.log('this.selectdItem.preStyle.selfStyle.showBtn',this.selectdItem.preStyle.selfStyle.showBtn)
					if(this.selectdItem.preStyle.selfStyle.showBtn) {
						return `${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[0]}px 0px 0px ${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[3]}px`
					}else{
						return `${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[0]}px ${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[2]}px ${this.selectdItem.preStyle.selfStyle.iptPad.borderRadius[3]}px`
					}
				}
				
			},
			getBtnBg(e) {
				console.log('this.enterBtn',this.enterBtn)
				let style = {}
				if (!this.enterBtn) {
					if (e.preStyle.selfStyle.bg.color && e.preStyle.selfStyle.bg.bgtype == 'color') {
						style.background = e.preStyle.selfStyle.bg.color
					}
					if (e.preStyle.selfStyle.bg.bgtype == 'gradient') {
						style = {
							...style,
							...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
						}
					}
				} else {
					if (e.preStyle.selfStyle.btnHover.bg.bgtype == 'color') {
						if(e.preStyle.selfStyle.btnHover.bg.color){
							style.background = e.preStyle.selfStyle.btnHover.bg.color
						}else{
							style.background = e.preStyle.selfStyle.bg.color
						}
					} else {
						
						if(e.preStyle.selfStyle.btnHover.bg.bgGradient){
							style = {
								...style,
								...this.cssStringToObject(e.preStyle.selfStyle.btnHover.bg.bgGradient)
							}
						}else{
							style = {
								...style,
								...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
							}
						}
			
					}
				}
			
			
				return style
			},
			getBtnColor(selectdItem) {
				if (!this.enterBtn) {
					return selectdItem.preStyle.selfStyle.btnFontColor
				}else{
					if(selectdItem.preStyle.selfStyle.btnHover.color){
						return selectdItem.preStyle.selfStyle.btnHover.color
					}else{
						return selectdItem.preStyle.selfStyle.btnFontColor
					}
				}
			},
			getSearchWidth(selectdItem) {
				if (this.equipment == 'pc') {
					return (selectdItem.preStyle.selfStyle.iptWidth - selectdItem.preStyle.border.borderSize[1] -
						selectdItem.preStyle.border.borderSize[3] - selectdItem.preStyle.padding[1] - selectdItem
						.preStyle.padding[3]) + 'px'
				} else {
					if (this.type == 'design') {
						return (selectdItem.preStyle.selfStyle.iptWidth - selectdItem.preStyle.border.borderSize[1] -
							selectdItem.preStyle.border.borderSize[3] - selectdItem.preStyle.padding[1] - selectdItem
							.preStyle.padding[3]) + 'px'
					} else {
						return (selectdItem.preStyle.selfStyle.iptWidth - selectdItem.preStyle.border.borderSize[1] -
							selectdItem.preStyle.border.borderSize[3] - selectdItem.preStyle.padding[1] - selectdItem
							.preStyle.padding[3]) + 'px'
					}
				}
			},
			isEmail(str) {
				var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
				return reg.test(str);
			},
			async sendEmail() {
				if (this.type == 'design') {
					return
				}
				if (this.isEmail(this.value)) {
					try {
						this.loading = true
						let data = await sendSubscribe({
							email: this.value
						})
						this.$message.success(data.data.message)
						this.loading = false
					} catch (e) {
						console.log('e',e)
						this.loading = false
					}
				} else {
					this.$message.error(this.$t('h.errorEmail'))
				}
				console.log('sendEmail', this.value)
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});
				return styleObject;
			},
			getPadding(e) {
				let style = {
					paddingTop: e.preStyle.selfStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.selfStyle.padding[2] + 'px',
					paddingLeft: e.preStyle.selfStyle.padding[1] + 'px',
					paddingRight: e.preStyle.selfStyle.padding[3] + 'px'
				}
				return style
			},
			getBg(e) {
				let style = {}
				if (e.preStyle.selfStyle.bg.color && e.preStyle.selfStyle.bg.bgtype == 'color') {
					style.background = e.preStyle.selfStyle.bg.color
				}
				if (e.preStyle.selfStyle.bg.bgtype && e.preStyle.selfStyle.bg.bgtype == 'img') {
					if (e.preStyle.selfStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.selfStyle.bg.img})`

						if (e.preStyle.selfStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.selfStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.selfStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.selfStyle.bg.bgImgHeigth +
								'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
						if (e.preStyle.selfStyle.bg.position) {
							style.backgroundPosition = e.preStyle.selfStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
					}
				}
				if (e.preStyle.selfStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
					}
				}

				return style
			},


			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.preStyle.selfStyle.border.borderRadius[0]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[2]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				if (this.iptEnter) {
					if (this.selectdItem.preStyle.selfStyle.borderHover.type && this.selectdItem.preStyle.selfStyle
						.borderHover.color) {
						let style = {}
						style.borderTop =
							`${this.selectdItem.preStyle.selfStyle.borderHover.type} ${this.selectdItem.preStyle.selfStyle.borderHover.borderSize[0]}px ${this.selectdItem.preStyle.selfStyle.borderHover.color}`
						style.borderLeft =
							`${this.selectdItem.preStyle.selfStyle.borderHover.type} ${this.selectdItem.preStyle.selfStyle.borderHover.borderSize[1]}px ${this.selectdItem.preStyle.selfStyle.borderHover.color}`
						style.borderBottom =
							`${this.selectdItem.preStyle.selfStyle.borderHover.type} ${this.selectdItem.preStyle.selfStyle.borderHover.borderSize[2]}px ${this.selectdItem.preStyle.selfStyle.borderHover.color}`
						style.borderRight =
							`${this.selectdItem.preStyle.selfStyle.borderHover.type} ${this.selectdItem.preStyle.selfStyle.borderHover.borderSize[3]}px ${this.selectdItem.preStyle.selfStyle.borderHover.color}`
						return style
					}

				}

				if (this.selectdItem.preStyle.selfStyle.border.type && this.selectdItem.preStyle.selfStyle.border.color) {
					let style = {}
					style.borderTop =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[0]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderLeft =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[1]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderBottom =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[2]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderRight =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[3]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					return style
				}
			},



			search() {
				this.$router.push({
					path: '/search_center'
				})
			},
			// changeValue() {
			// 	if (!this.value) {
			// 		return
			// 	}
			// 	this.$router.push({
			// 		path: '/products_search/search?keyword=' + this.value,

			// 	})
			// 	// window.location.reload();
			// },
			handleClose() {
				if (this.type == 'design') {
					return
				}
				this.drawer = false
			}

		}
	}
</script>

<style scoped>
	::v-deep .el-input__inner {
		font-size: 22px;
		padding: 10px;
		border: 0px;
		border-radius: var(--borderRadius);
	}

	::v-deep .el-input-group__append {
		border-radius: 0px;

		.el-button {
			border-radius: 0px;
			line-height: 0px;
		}
	}

	::v-deep .el-input-group__append {
		background-color: rgb(0 0 0 / 0%);
		border: solid 0px #fff;
		padding-top: 1px;
		/* display: flex;
		justify-content: center;
		align-items: center; */
	}
	
	/* 大型占位文本 */
	.large-placeholder::v-deep .el-input__inner::placeholder {
	  font-size: var(--placeholderSize);
	}
</style>